export class CountryNexusSetting {
  business_name: string = '';
  calculate_sales_tax: boolean = false;
  created_at?: Date;
  nexus_establishment_date: string = '';
  payment_schedule: string = '';
  shipping_tax_included: string = '';
  country_nexus_id?: number;
  country_code: string = '';
  region_code?: string = '';
  tax_regime?: string = '';
  vat_tax_id: string = '';
  updated_at?: Date;
  user_id?: string = '';
  business_profile_id?: number;
}
